import {
  setPolicyDetails,
  SET_MEMBER_DETAIL_UPDATED
} from "../policy/policyActions";
import { LoginStatus } from "../../constants/Constants";
import { Paths } from "../../constants/UrlConstants";
import { internalViewLogin } from "./../../services/InternalViewLogin";
import { USER_FOUND } from "redux-oidc";
import { trackException } from "../../logging/AppInsightsLogger";
import { redirectToErrorPageMessage } from "../../logging/CommonLogMessages";

export const SET_LOGGED_IN_STATE = "SET_LOGGED_IN_STATE";
export const DO_LOGIN_AUTH = "DO_LOGIN_AUTH";
export const SET_SESSION_TIMEOUT = "SET_SESSION_TIMEOUT";
export const SET_XSRF_TOKEN = "SET_XSRF_TOKEN";

export function setLoggedInState(isLoggedIn) {
  return {
    type: SET_LOGGED_IN_STATE,
    payload: isLoggedIn
  };
}

export function onLoginError(username, response, history) {
  if (response.status === LoginStatus.Locked) {
    history.push(Paths.Locked);
  } else if (response.status === LoginStatus.PolicyLocked) {
    history.push(Paths.PolicyLocked);
  } else if (response.status === LoginStatus.InvalidPolicyStatus) {
    history.push(Paths.OnlineAccessUnavailable);
  } else if (response.status === LoginStatus.RestrictedPolicy) {
    history.push(Paths.RestrictedPolicy);
  } else if (response.status === LoginStatus.RestrictedGroup) {
    history.push(Paths.RestrictedGroup);
  } else if (response.status === LoginStatus.Restricted) {
    history.push(Paths.RestrictedUser);
  } else if (response.status === LoginStatus.SystemUnavailable) {
    history.push(Paths.SystemUnavailable);
  } else if (response.status === LoginStatus.MovedToAxaHealth) {
    history.push(Paths.MovedToAxaHealth);
  } else {
    trackException(
      redirectToErrorPageMessage,
      `Something went wrong in onLoginError. Username: ${username}, responseStatus: ${JSON.stringify(
        response.status
      )}`
    );
    history.push(Paths.Error);
  }
}

export function setSessionTimeout(timedout) {
  return {
    type: SET_SESSION_TIMEOUT,
    payload: timedout
  };
}

export function doB2CInternalViewLogin(token, history) {
  return async (dispatch) => {
    let response = await internalViewLogin(token);
    if (response !== undefined && response !== null) {
      if (response.status === LoginStatus.Valid) {
        await dispatch(setPolicyDetails(history, true));
        dispatch(setLoggedInState(true));
      } else if (response.status === LoginStatus.SessionFailure) {
        return response;
      } else {
        onLoginError(null, response, history);
      }
    }
    return;
  };
}

export function setOIDCUser(user) {
  return async (dispatch) => {
    if (user) {
      await dispatch({
        type: USER_FOUND,
        payload: user
      });
    }
  };
}

export function setMemberDetailUpdated(response) {
  return async (dispatch) => {
    await dispatch({
      type: SET_MEMBER_DETAIL_UPDATED,
      payload: response
    });
  };
}
